import { useEffect, useState } from 'react';
import _ from 'lodash';
export const MAX_AVATARS = 8;

export const useGetEffectiveContirbutorsAvatars = ({
  contributors = [],
  effectiveContributors = []
}) => {
  const [avatars, setAvatars] = useState([]);
  const [indirect, setIndirect] = useState(0);
  const [restAvatars, setRestAvatars] = useState(0);

  useEffect(() => {
    const { avatars, indirect, restAvatars } = getEffectiveContirbutorsAvatars({
      contributors,
      effectiveContributors
    });
    setAvatars(avatars);
    setIndirect(indirect);
    setRestAvatars(restAvatars);
  }, [contributors, effectiveContributors]);

  return {
    avatars,
    indirect,
    restAvatars
  };
};

export const getEffectiveContirbutorsAvatars = ({
  contributors = [],
  effectiveContributors = []
}) => {
  const listsAreIdentical =
    _.xorBy(contributors, effectiveContributors || [], ({ id }) => id)
      .length === 0;
  const noEffective = effectiveContributors === null;
  const showGhostAvatar = !listsAreIdentical && !noEffective;

  /*
     * State 1 - Shows avatar 1,2,3
      {
        Contributors: [1,2,3],
        effective_contributors: null
      }
    */

  if (effectiveContributors === null && contributors.length) {
    return {
      avatars: contributors.slice(0, MAX_AVATARS),
      restAvatars:
        contributors.length > MAX_AVATARS
          ? contributors.length - MAX_AVATARS
          : 0,
      indirect: 0,
      showGhostAvatar
    };
  }

  /**
   * State 2 - No effective work (Message needed) + 3 Indirect
    {
      Contributors: [1,2,3],
      Effective_contributors: []
    }
   */
  if (
    _.isArray(effectiveContributors) &&
    effectiveContributors.length === 0 &&
    contributors.length
  ) {
    return {
      avatars: [],
      restAvatars: 0,
      indirect: contributors.length,
      showGhostAvatar
    };
  }

  /**
   * State 3 - 2 avatars + {rest} indirect
    {
      Contributors: [1,2,3],
      Effective_contributors: [1,2]
    }
   */
  if (
    _.isArray(effectiveContributors) &&
    effectiveContributors.length &&
    contributors.length
  ) {
    return {
      avatars: effectiveContributors.slice(0, MAX_AVATARS),
      restAvatars:
        effectiveContributors.length > MAX_AVATARS
          ? effectiveContributors.length - MAX_AVATARS
          : 0,
      indirect: _.xorBy(effectiveContributors, contributors, ({ id }) => id)
        .length,
      showGhostAvatar
    };
  }

  return {
    avatars: [],
    restAvatars: [],
    indirect: 0,
    showGhostAvatar: false
  };
};
